import ProjectDetail from "../components/Projects/ProjectDetail";

const ProjectDetailPage = () => {
  return <ProjectDetail />;
};

export default ProjectDetailPage;
